import { render, staticRenderFns } from "./CardTarjaGETV.vue?vue&type=template&id=0d3d8f0e&scoped=true"
import script from "./CardTarjaGETV.vue?vue&type=script&lang=js"
export * from "./CardTarjaGETV.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaGETV.vue?vue&type=style&index=0&id=0d3d8f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d8f0e",
  null
  
)

export default component.exports